import { useState, useEffect } from 'react';
import useInstrutorStore from '../../store/useInstrutorStore';
import useUserStore from '../../store/useUserStore';
import Select from '../../components/select';
import { Button, Input } from '../../components/all';
import { ToastContainer } from 'react-toastify';

import { useLocation } from 'react-router-dom';
import useAula from '../../hooks/useAula';
import { addDays, format } from 'date-fns';
import toast from '../../utils/toast';

export default function CreateAula() {

  const { SelectVeicleByInstrutor, SearchAndFilterHour, InsertClass } = useAula();

  const getAutoescolaId = () => {
    const id = sessionStorage.getItem("autoescola_id");
    return id ? parseInt(id) : null;
  };

  const hoje = format(new Date(), 'yyyy-MM-dd');
  const seteDias = format(addDays(new Date(), 7), 'yyyy-MM-dd');

  const location = useLocation();
  const { aluno } = location.state || {};
  const { instrutor } = useInstrutorStore();
  const { usuario } = useUserStore();
  const categoria = instrutor.tipo_instrutor;

  const [selectedTipo, setTipo] = useState('');
  const [selectedVeiculo, setVeiculo] = useState('');
  const [selectedHora, setHora] = useState('');

  const categorias = categoria.split("");
  const [veiculos, setVeiculos] = useState([]);
  const [horas, setHoras] = useState([]);
  const [dataSelecionada, setDataSelecionada] = useState('');

  const showToast = (type, text1, text2) => {
    toast.dismiss();
    toast[type](`${text1}: ${text2}`);
  };

  const changeComboTipo = (item) => setTipo(item);
  const changeComboVeiculo = (item) => setVeiculo(item);
  const changComboHora = (item) => setHora(item);

  const changeData = (novaData) => {
    const formatedDate = format(novaData, 'yyyy-MM-dd');
    setDataSelecionada(formatedDate);
  };

  const createAula = async () => {

    if (!selectedTipo || !selectedVeiculo || !selectedHora || !dataSelecionada) {
      showToast('error', 'Campos obrigatórios', 'Preencha todos os campos antes de continuar!');
      return;
    }

    const veiculoSelecionado = veiculos.find(v => v.placa === selectedVeiculo);
    const idDoVeiculo = veiculoSelecionado?.veiculo_id;

    if (!idDoVeiculo) {
      showToast('error', 'Veículo inválido', 'Selecione um veículo válido!');
      return;
    }

    const autoescola_id = getAutoescolaId();

    const aula1 = {
      instrutor_id: instrutor.instrutor_id,
      aluno_id: aluno.usuario_id,
      data: dataSelecionada,
      tipo: selectedTipo,
      hora: selectedHora,
      veiculo_id: idDoVeiculo,
      autoescola_id: autoescola_id,
      marcada_por: 2,
      configuracoes: usuario.configuracoes
    };

    const result = await InsertClass(aula1);

    if (result.success) {
      showToast('success', 'Sucesso', 'Aula marcada com sucesso!');
      setHora('');
      setVeiculo('');
      setTipo('');
    } else {
      showToast('error', 'Erro ao criar aula', result.error);
    }
  };

  useEffect(() => {
    if (!selectedTipo || !selectedVeiculo || !dataSelecionada) return;
    const searchHoras = async () => {
      const veiculoSelecionado = veiculos.find(v => v.placa === selectedVeiculo);
      const idDoVeiculo = veiculoSelecionado?.veiculo_id;
      const response = await SearchAndFilterHour(instrutor.instrutor_id, idDoVeiculo, dataSelecionada);
      setHoras(response);
    }
    searchHoras();
  }, [selectedTipo, selectedVeiculo, dataSelecionada, SearchAndFilterHour, instrutor.instrutor_id, veiculos]);

  useEffect(() => {
    const autoescola_id = getAutoescolaId();
    if (!selectedTipo) return;
    const searchVeiculos = async () => {
      const response = await SelectVeicleByInstrutor(instrutor.instrutor_id, selectedTipo, autoescola_id);
      setVeiculos(response || []);
    }
    searchVeiculos();
  }, [selectedTipo, SelectVeicleByInstrutor, instrutor.instrutor_id]);

  return (
    <div className="min-h-[90vh] flex items-center justify-center p-4 bg-background dark:bg-neutral-900">
      <div className="w-full max-w-lg rounded-none p-6 flex flex-col gap-6 bg-card dark:bg-neutral-800 border-2 border-border dark:border-neutral-700 shadow-sm">

        {/* Header */}
        <div className="flex flex-col gap-1">
          <h1 className="text-2xl font-bold text-foreground dark:text-neutral-100">Marcar aula</h1>
          <p className="text-sm text-muted-foreground dark:text-neutral-400">
            Preencha os dados abaixo para agendar a aula
          </p>
        </div>

        {/* Aluno */}
        <div className="flex flex-col gap-1">
          <span className="text-xs font-semibold text-gray-500 uppercase">Aluno</span>
          <Input
            disabled={true}
            value={`${aluno.nome} ${aluno.sobrenome}`}
            className="capitalize bg-gray-100"
          />
        </div>

        {/* Tipo + Veículo */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="flex flex-col gap-1">
            <span className="text-xs font-semibold text-gray-500 uppercase">Tipo da aula</span>
            <Select
              value={selectedTipo}
              onChange={(a) => changeComboTipo(a.target.value)}
              options={categorias}
              placeholder={"Selecione o tipo"}
              className="opacity-100"
            />
          </div>

          <div className="flex flex-col gap-1">
            <span className="text-xs font-semibold text-gray-500 uppercase">Veículo</span>
            <Select
              value={selectedVeiculo}
              onChange={(a) => changeComboVeiculo(a.target.value)}
              options={veiculos.map(v => v.placa)}
              placeholder={"Selecione o veículo"}
              disabled={!selectedTipo}
              className={`${!selectedTipo ? "opacity-70 cursor-not-allowed" : "opacity-100"}`}
            />
          </div>
        </div>

        {/* Data */}
        <div className="flex flex-col gap-1">
          <span className="text-xs font-semibold text-gray-500 uppercase">Data</span>
          <Input
            type='date'
            min={hoje}
            max={seteDias}
            value={dataSelecionada}
            onChange={e => changeData(addDays(new Date(e.target.value), 1))}
            disabled={!selectedTipo || !selectedVeiculo}
            className={`${(!selectedTipo || !selectedVeiculo) ? "bg-gray-100 cursor-not-allowed" : ""}`}
          />
          <div className='flex gap-3 mt-2'>
            <Button
              type={5}
              onClick={() => changeData(new Date())}
              disabled={!selectedTipo || !selectedVeiculo}
            >
              Hoje
              <span className="material-icons">date_range</span>
            </Button>
            <Button
              type={5}
              disabled={!selectedTipo || !selectedVeiculo}
              onClick={() => changeData(addDays(new Date(), 1))}
            >
              Amanhã
              <span className="material-icons">calendar_month</span>
            </Button>
          </div>
        </div>

        {/* Hora */}
        <div className="flex flex-col gap-1">
          <span className="text-xs font-semibold text-gray-500 uppercase">Horário</span>
          <Select
            value={selectedHora}
            onChange={(a) => changComboHora(a.target.value)}
            options={horas}
            placeholder={"Selecione o horário"}
            disabled={!selectedTipo || !selectedVeiculo || !dataSelecionada}
            className={`${(!selectedTipo || !selectedVeiculo || !dataSelecionada) ? "opacity-70 cursor-not-allowed" : "opacity-100"}`}
          />
        </div>

        {/* CTA */}
        <Button className='mt-2' onClick={createAula}>
          Finalizar agendamento
          <span className="material-icons">check</span>
        </Button>
        <div className='h-20'/>
      </div>

      <ToastContainer position="top-center" />
    </div>
  )
}
